import React, { useState, useEffect, useCallback } from "react";

const AnimatedNavIcon = ({ isClickable, linkHasBeenClicked, setLinkHasBeenClicked }) => {
  const [fadeOutInternal, setFadeOutInternal] = useState(false);
  const [crossExternalUp, setCrossExternalUp] = useState(false);
  const [crossExternalDown, setCrossExternalDown] = useState(false);
  const [animationIsTriggered, setAnimationIsTriggered] = useState(false);

  const triggerAnimation = useCallback(() => {
    if (!linkHasBeenClicked && !isClickable) return;
    if (animationIsTriggered === false) {
      setAnimationIsTriggered(true);
      setFadeOutInternal(true);
      setCrossExternalUp(true);
      setCrossExternalDown(true);
    } else {
      setAnimationIsTriggered(false);
      setFadeOutInternal(false);
      setCrossExternalUp(false);
      setCrossExternalDown(false);
    }
  }, [animationIsTriggered, isClickable, linkHasBeenClicked]);

  useEffect(() => {
    if (linkHasBeenClicked) {
      triggerAnimation();
      setLinkHasBeenClicked(false);
    }
  }, [linkHasBeenClicked, setLinkHasBeenClicked, triggerAnimation]);

  return (
    <div id="animatedNavIcon" onClick={triggerAnimation}>
      <div className={`container ${crossExternalUp ? "moveDown" : ""}`}>
        <div className={`line-out ${crossExternalUp ? "rotateUp" : "initialUp"} `} />
      </div>
      <div className="container-center">
        <div className={`line-center ${fadeOutInternal ? "fadeOut" : "fadeIn"} `} />
      </div>
      <div className={`container ${crossExternalUp ? "moveUp" : ""}`}>
        <div className={`line-out ${crossExternalDown ? "rotateDown" : "initialDown"} `} />
      </div>
    </div>
  );
};

export default AnimatedNavIcon;
